import React, { Dispatch, SetStateAction, useEffect } from 'react';
import { FaExclamationCircle } from 'react-icons/fa';

import { UseOutletContextInventory } from '../Inventory';
import { StateLanguage } from '../../../../languages/config/StateLanguage';
import { uploadTooltip } from '../../../../tools/tooltip.tool';

import AppInputAccountingAccount from '../../../../components/element/InputAccountingAccount';

export interface AppInventoryFormAccountingAccountProps {
  component?: string,
  accounts: {value: {expense: string, vat: string, product: string}, valid: {expense: boolean, vat: boolean, product: boolean}},
  setAccounts: Dispatch<SetStateAction<{value: {expense: string, vat: string, product: string}, valid: {expense: boolean, vat: boolean, product: boolean}}>>
};

const AppInventoryFormAccountingAccount: React.FunctionComponent<AppInventoryFormAccountingAccountProps> = ({component, accounts, setAccounts}) => {
  const {companyForUser, accountingExpenseAccountsForCompany, accountingVatAccountsForCompany, accountingProductAccountsForCompany} = UseOutletContextInventory()
  const {lang} = StateLanguage()

  useEffect( () => {
    uploadTooltip()

  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [companyForUser, accountingExpenseAccountsForCompany, accountingVatAccountsForCompany, accountingProductAccountsForCompany])

  return (
    <>
      { companyForUser && accountingExpenseAccountsForCompany && accountingVatAccountsForCompany && accountingProductAccountsForCompany &&
        <>
          <div className="fv-row mb-3">
            <label className="form-label">
              <div className="d-flex align-items-center">
                <span className="required">{lang.labels.expenseAccount}</span>
                <i className="ms-2 fs-8" data-bs-toggle="tooltip" data-bs-trigger="hover" data-bs-original-title={lang.labels.accountingAccountPurchases}><FaExclamationCircle /></i>
              </div>
            </label>
            <AppInputAccountingAccount component={component} options={{small: false, type: "expense", index: null, item: null}} companyForUser={companyForUser} accountingExpenseAccountsForCompany={accountingExpenseAccountsForCompany} accountingProductAccountsForCompany={accountingProductAccountsForCompany} accountingVatAccountsForCompany={accountingVatAccountsForCompany} accounts={accounts} setAccounts={setAccounts}></AppInputAccountingAccount>
          </div>
          <div className="fv-row mb-3">
            <label className="form-label">
              <div className="d-flex align-items-center">
                <span className="required">{lang.labels.vatAccount}</span>
                <i className="ms-2 fs-8" data-bs-toggle="tooltip" data-bs-trigger="hover" data-bs-original-title={lang.labels.accountingAccountPurchases}><FaExclamationCircle /></i>
              </div>
            </label>
            <AppInputAccountingAccount component={component} options={{small: false,type: "vat", index: null, item: null}} companyForUser={companyForUser} accountingExpenseAccountsForCompany={accountingExpenseAccountsForCompany} accountingProductAccountsForCompany={accountingProductAccountsForCompany} accountingVatAccountsForCompany={accountingVatAccountsForCompany} accounts={accounts} setAccounts={setAccounts}></AppInputAccountingAccount>
          </div>
          <div className="fv-row">
            <label className="form-label">
              <div className="d-flex align-items-center">
                <span className="required">{lang.labels.accountProduct}</span>
                <i className="ms-2 fs-8" data-bs-toggle="tooltip" data-bs-trigger="hover" data-bs-original-title={lang.labels.accountingAccountSales}><FaExclamationCircle /></i>
              </div>
            </label>
            <AppInputAccountingAccount component={component} options={{small: false,type: "product", index: null, item: null}} companyForUser={companyForUser} accountingExpenseAccountsForCompany={accountingExpenseAccountsForCompany} accountingProductAccountsForCompany={accountingProductAccountsForCompany} accountingVatAccountsForCompany={accountingVatAccountsForCompany} accounts={accounts} setAccounts={setAccounts}></AppInputAccountingAccount>
          </div>
        </>
      }
    </>
  )
};

export default AppInventoryFormAccountingAccount;
